import _objectSpread from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is

/**
 * @internal
 */
function addAutoIpAddressToUser(objWithMaybeUser) {
  var _objWithMaybeUser$use;

  if (((_objWithMaybeUser$use = objWithMaybeUser.user) === null || _objWithMaybeUser$use === void 0 ? void 0 : _objWithMaybeUser$use.ip_address) === undefined) {
    objWithMaybeUser.user = _objectSpread(_objectSpread({}, objWithMaybeUser.user), {}, {
      ip_address: '{{auto}}'
    });
  }
}
/**
 * @internal
 */


function addAutoIpAddressToSession(session) {
  if ('aggregates' in session) {
    var _session$attrs;

    if (((_session$attrs = session.attrs) === null || _session$attrs === void 0 ? void 0 : _session$attrs['ip_address']) === undefined) {
      session.attrs = _objectSpread(_objectSpread({}, session.attrs), {}, {
        ip_address: '{{auto}}'
      });
    }
  } else {
    if (session.ipAddress === undefined) {
      session.ipAddress = '{{auto}}';
    }
  }
}

export { addAutoIpAddressToSession, addAutoIpAddressToUser };